/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { _ as __assign } from '../../tslib.es6-e01eabb2.js';
import { v as index$s } from '../../index-e5fa4dec.js';
import { extend } from '../extend/index.js';
import navigateTo$4 from './cn/index.js';
import navigateTo$5 from './cnStation/index.js';
import navigateTo$6 from './tb/index.js';
import navigateTo$8 from './ali1688/index.js';
import navigateTo$7 from './fm/index.js';
import navigateTo$3 from './nebula/index.js';
import navigateTo$1 from './dingTalk/index.js';
import navigateTo$2 from './dingTalkPC/index.js';
import mini from './mini/index.js';
import navigateTo$9 from './panguMiniApp/index.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';
import '../../common-42e7d8d8.js';
import '../../safe-data-66f20265.js';
import '../../index-ee2c9aee.js';

// api: https://uni-apis.alibaba-inc.com/doc/Navigation/navigateto
var apiConfig = {
    web: {
        dingTalk: navigateTo$1,
        dingTalkPC: navigateTo$2,
        nebula: navigateTo$3,
        windvane: {
            // 菜鸟系
            cn: navigateTo$4,
            cnStation: navigateTo$5,
            // 淘系
            tb: navigateTo$6,
            tbLive: navigateTo$6,
            fm: navigateTo$7,
            ali1688: navigateTo$8,
        },
    },
    mini: mini,
    panguMiniApp: navigateTo$9,
};
var extendNavigateTo = extend(apiConfig, index$s);
/**
 * 打开新的WebView新窗口。API：https://yuque.antfin.com/cn-xt/arch/lwbvd0
 * 注意: 该API不是页面路由，而是App端新开1个webview实例。打个比方是：google浏览器新开tab，而不是更新当前页
 * @param  {!string|NavigateToIOptions} url 新窗口url或者NavigateToIOptions（详细见如下）对象（兼容2种传参方式）
 * @param  {?NavigateToParams} params 当第一个参数为string格式时，此参数有效。
 * @returns {Promise<unknown>} promise调用结果

 * NavigateToIOptions 全部参数
 * @property  {!string}            NavigateToIOptions.url 新窗口url，必填
 * @property  {?boolean}           [NavigateToIOptions.killSelf=false] 开启新窗口时，是否关闭当前webview
 * @property  {?Function}          [NavigateToIOptions.onResume] 回到当前页面时的回调，常用来刷新页面
 * @example 使用案例：
 * import { navigateTo } from '@alife/cn-uni-api';
 *  navigateTo({
 *    url: 'https://xx.xx/',
 *    killSelf: false, // killSelf 参数暂时只支持 菜鸟 ｜ 淘宝 | 支付宝 | 闲鱼
 *    onResume: () => {} // onResume 参数暂时只支持 菜鸟 ｜ 淘宝 | 支付宝 | 闲鱼
 *  })
 *    .then(() => {
 *      console.log('success');
 *    })
 *    .catch((error) => {
 *      console.log(error);
 *    });
 * @author 敬文
 */
var navigateTo = function (url, params) {
    if (typeof url === 'string') {
        return extendNavigateTo(__assign(__assign({}, params), { url: url }));
    }
    return extendNavigateTo(url);
};

export { extendNavigateTo, navigateTo };
